import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { CurrencyMoneyInput } from '../../shared/simple/CurrencyMoneyInput';
import { Col } from 'react-bootstrap';
import { useDisabled, useTextLanguage } from '../../../hooks/useShared';
import { useEdit } from '../../../hooks/useEdit';
import { useMoneyInput } from '../../../hooks/useInput';
import { useSelector } from 'react-redux';

/**
 * Component text input to money
 * @component
 * @param {Object} field
 * @returns
 */
export const MoneyInput = ({ field, isNewDesign=false }) => {
  const uniqueName = `${field.unique_name}__id__${field.id}`;
  const { description, languageText } = useTextLanguage();
  const { register, formState: { errors } } = useFormContext();
  const { onChange, type, value, action } = useMoneyInput(field,  uniqueName);
  const { colSize } = useEdit(field);
  const { isDisabled } = useDisabled(field);
  const { defaultValuesTier } = useSelector(state => state.tier)
  const defaultValue = defaultValuesTier ? defaultValuesTier[uniqueName] : null;

  return (
    <>
      {field && (
        <>
          {(colSize?.includes('col-before')) && (
            <Col xs={12} key={`col_before_${field.id}`}></Col>
          )}
          <Col
            className={ colSize }
            data-module={ `module-${field?.category?.field_category}` }
            data-name={ uniqueName }
            id={ `group_field_${field.id}` }
            key={ field.id }
            xs={12}
            aria-describedby={action?.ariaDescribedBy || undefined}
          >
            <CurrencyMoneyInput
              isNewDesign={isNewDesign}
              field={ field }
              isRequiredInput={ field?.required }
              label={ field?.[description] }
              message={ errors?.[uniqueName]?.message }
              name={ uniqueName }
              onChange={ onChange }
              placeholder={ field?.[`placeholder${languageText}`] }
              register={ register }
              tooltipText={ field?.[`tooltip${languageText}`] }
              type={ type }
              value={value}
              disabled={isDisabled}
              defaultValue={defaultValue}
            />
          </Col>
        </>
      )}
    </>
  );
};

MoneyInput.propTypes = {
  field: PropTypes.object.isRequired
};